<template>
  <div class="artist-card">
    <router-link
      :to="artistLink"
      @click.native="logClick"
      class="artist-card-link card-animation-on-hover-no-bg"
    >
      <div class="artist-card-header">
        <img
          v-if="displayImage"
          v-lazy="lazyImageSrc"
          :style="{ borderColor: this.secondaryColor }"
          class="artist-card-image"
          :alt="artistName"
          height="80px"
          width="80px"
        />
        <div class="artist-info">
          <span class="artist-card-name">{{ artistName }}</span>
          <!--          <small style="text-transform: uppercase">{{ event.metadata.caption }}</small>-->
          <small class="event-location-line">{{ eventLocationLineDisplay }}</small>
          <p v-if="event.metadata && event.metadata.start_time" class="event-time">
            <strong>

              {{ event.metadata.start_time }} hrs -

              {{ getMonthShort(fullEventDateTime) }}
              {{ getDayNumeric(fullEventDateTime) }}
            </strong>

          </p>
          <p v-else-if="event.metadata && event.metadata.date" class="event-time">
            {{ getDay(event.metadata.date + 'T00:00') }},
            {{ getMonthShort(event.metadata.date + 'T00:00') }}
            {{ getDayNumeric(event.metadata.date + 'T00:00') }}
          </p>
        </div>
      </div>
    </router-link>

    <div>
      <div v-if="showContent && event.content" class="artist-card-content">
        <hr />
        <div v-html="event.content" class="content-html"></div>
      </div>
    </div>

    <div class="actions-footer text-center" v-if="eventLink.path || eventLink.name">
      <router-link :to="eventLink" @click.native="logClick" class="btn artist-btn-sm">
        Event Details & Tickets
      </router-link>
    </div>
    <div v-for="e in genrePills">
      <label class="badge-pill">{{e}}</label>
    </div>
  </div>
</template>

<script>
import { eventDateMixin } from '@/common/eventDateMixin';

export default {
  name: 'ArtistCard',
  mixins: [eventDateMixin],
  props: {
    event: {
      type: Object,
      default: () => ({
        title: 'N/A', // Provide a default title
        metadata: { image_url: '', date: null, start_time: null, event_link: '', artist_link: '' },
        content: ''
      })
    },
    image: { // Prop for explicit image URL, overrides event.metadata.image_url
      type: String,
      default: ''
    },
    showContent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // expandTab: false, // This was in original but not used in template snippet
      secondaryColor: 'rgb(255, 141, 114)' // Example color, can be a prop
    };
  },
  computed: {
    displayImage() {
      return this.image || (this.event && this.event.metadata && this.event.metadata.image_url);
    },
    lazyImageSrc() {
      const imgSrc = this.image || (this.event && this.event.metadata && this.event.metadata.image_url);
      return imgSrc ? `${imgSrc}?q=&w=80&h=80&fit=clamp&auto=format` : ''; // Increased size slightly for clarity
    },
    artistName() {
      if (this.event && this.event.title && typeof this.event.title === 'string') {
        return this.event.title.split('@')[0].trim();
      }
      return 'Untitled Event';
    },
    eventLocationPart() {
      if (this.event && this.event.title && typeof this.event.title === 'string') {
        const parts = this.event.title.split('@');
        if (parts.length > 1 && parts[1]) {
          return parts[1].split('|')[0].trim();
        }
      }
      return '';
    },
    eventBrandPart() {
      if (this.event && this.event.title && typeof this.event.title === 'string') {
        const parts = this.event.title.split('@');
        if (parts.length > 1 && parts[1]) {
          const locationAndBrand = parts[1].split('|');
          if (locationAndBrand.length > 1 && locationAndBrand[1]) {
            return locationAndBrand[1].trim();
          }
        }
      }
      return '';
    },
    eventLocationLineDisplay() {
      let line = this.eventLocationPart;
      if (this.eventBrandPart) {
        line += (line ? ' @ ' : '') + this.eventBrandPart; // Use brand as venue if location is empty
      }
      return line || 'Location TBD';
    },
    fullEventDateTime() {
      if (this.event && this.event.metadata && this.event.metadata.date) {
        return `${this.event.metadata.date}T${this.event.metadata.start_time || '00:00:00'}`;
      }
      return new Date().toISOString(); // Fallback, though ideally should not be needed if date is present
    },
    eventLink() {
      // Ensure a valid path for router-link, even if it's just to home
      const path = this.event && this.event.metadata && this.event.metadata.event_link
        ? this.event.metadata.event_link
        : { name: 'Home' }; // Fallback to a named route 'Home' or '/'
      return typeof path === 'string' ? { path } : path;
    },
    artistLink() {
      if (this.event && this.event.metadata && this.event.metadata.artist_link) {
        return { path: this.event.metadata.artist_link };
      }
      return {};
    },
    genrePills() {
      if (this.event && this.event.metadata && this.event.metadata.genre) {
        return this.event.metadata.genre.split(/\||,|\&/);
      }
      return '';
    }
  },
  methods: {
    // expand() { // This was in original but not used in template snippet
    //   this.expandTab = !this.expandTab;
    // },
    logClick() {
      // Using Rollbar instance if available globally or injected
      if (this.$rollbar && this.event && this.event.title) {
        this.$rollbar.info('Artist Card Clicked', { eventTitle: this.event.title, link: this.eventLink });
      } else {
        console.log('Artist Card Clicked:', this.event ? this.event.title : 'N/A', 'Link:', this.eventLink);
      }
    }
  }
};
</script>


